import fetch from 'isomorphic-fetch';

import { showErrorBar } from 'actions/errorBar';
import { ERROR } from 'constants/error-severities';
import { HEADER_CONTENT_TYPE } from 'constants/http';
import { JSON as JSON_MIME } from 'constants/mimes';
import { VideoVisibility } from 'constants/visibility';
import UpdateVideoVisibility from 'creators/UpdateVideoVisibility.graphql';
import { getGraphQLClient } from 'utilities/graphql';
import * as sentry from 'utilities/sentry';

import DuplicateVideo from './DuplicateVideo.graphql';
import { showConfirmationModal } from '../actions/confirmationModal';

export function duplicateVideoCreator(id, newName = null) {
  return dispatch => {
    return fetch('/v1/videos/duplicate', {
      credentials: 'include',
      headers: { [HEADER_CONTENT_TYPE]: JSON_MIME },
      method: 'POST',
      body: JSON.stringify({ id, newName }),
    })
      .then(resp => {
        if (resp.status >= 400) {
          throw new Error(
            `Oops! Error duplicating video - HTTP response: ${resp.status}`
          );
        }

        return resp.json();
      })
      .then(newVideoJSON => {
        dispatch(
          showConfirmationModal(`${newVideoJSON.name} successfully created 🤓`)
        );

        return newVideoJSON;
      })
      .catch(err => {
        sentry.logException(err, 'error in duplicate video creator');
        dispatch(showErrorBar(ERROR, err.toString()));
      });
  };
}

export function duplicateVideoGraphQL(videoId, newName) {
  return dispatch => {
    getGraphQLClient()
      .mutate({
        mutation: DuplicateVideo,
        variables: { videoId, newName },
        refetchQueries: ['GetLooms'],
      })
      .then(({ data }) => {
        if (data.duplicateVideo.__typename === 'GenericError') {
          dispatch(showErrorBar(ERROR, data.duplicateVideo.message));
        } else {
          dispatch(
            showConfirmationModal(
              `${data.duplicateVideo.newVideo.name} successfully created`
            )
          );
        }
      });
  };
}

export function publishVideosGraphQL(videoIds, isPublished) {
  return async dispatch => {
    await Promise.all(
      videoIds.map(videoId => {
        getGraphQLClient()
          .mutate({
            mutation: UpdateVideoVisibility,
            variables: {
              videoId,
              visibility: isPublished
                ? VideoVisibility.WORKSPACE
                : VideoVisibility.OWNER,
            },
          })
          .then(({ data }) => {
            if (data.updateVideoVisibility.__typename === 'GenericError') {
              dispatch(showErrorBar(ERROR, data.updateVideoVisibility.message));
            }
          });
      })
    );
  };
}
